import { INewDwellingProjectData, INewDwellingProspectUnits, IProjectTotals, IStageTotals } from '../../newdwelling.model';

export function getZeroAsNull(value: number | null): number | null {
    return (value || 0) === 0 ? null : value;
}

export function buildProjectTotals(projectData: INewDwellingProjectData): IProjectTotals {
    const info = projectData?.projectInfo;
    const model = info?.stageEstateTypesModel;
    return {
        totalUnits: info?.numUnits || 0,
        totalAveragePrice: getZeroAsNull(model?.totalStatisticsValues?.avaragePrice),
        totalPricePerM2: getZeroAsNull(model?.totalStatisticsValues?.avaragePricePerSqm),
        totalAverageSqm: getZeroAsNull(model?.totalStatisticsValues?.avarageSqm),
        totalPrice: getZeroAsNull(model?.totalStatisticsValues?.totalPrice),

        totalSoldUnits: info?.numberSold || 0,
        totalUnsoldUnits: (info?.numUnits || 0) - (info?.numberSold || 0),

        totalSoldAveragePrice: getZeroAsNull(model?.totalStatisticsSoldValues?.avaragePrice),
        totalSoldPricePerM2: getZeroAsNull(model?.totalStatisticsSoldValues?.avaragePricePerSqm),
        totalSoldAverageSqm: getZeroAsNull(model?.totalStatisticsSoldValues?.avarageSqm),
        totalSoldPrice: getZeroAsNull(model?.totalStatisticsSoldValues?.totalPrice),

        totalUnsoldAveragePrice: getZeroAsNull(model?.totalStatisticsUnsoldValues?.avaragePrice),
        totalUnsoldPricePerM2: getZeroAsNull(model?.totalStatisticsUnsoldValues?.avaragePricePerSqm),
        totalUnsoldAverageSqm: getZeroAsNull(model?.totalStatisticsUnsoldValues?.avarageSqm),
        totalUnsoldPrice: getZeroAsNull(model?.totalStatisticsUnsoldValues?.totalPrice),

        precentageSold: (info?.numberSold || 0) / (info?.numUnits || 1),
        precentageUnsold: ((info?.numUnits || 0) - (info?.numberSold || 0)) / (info?.numUnits || 1),
    };
}

export function buildStageTotals(projectData: INewDwellingProjectData, projectStageEstateTypeId?: number): IStageTotals[] {
    let stages = projectData?.projectInfo?.stageEstateTypesModel?.projectStageEstateTypes || [];

    if(projectStageEstateTypeId != null && projectStageEstateTypeId > 0) {
        stages = stages.filter(stage => stage.projectStageEstateTypeId === projectStageEstateTypeId);
    }

    return stages.map(stage => {
        const totalSold = stage.numberSold || 0;
        const totalUnsold = (stage.numUnits || 0) - totalSold;
        const percentageSold = stage.numUnits ? (totalSold / stage.numUnits) : 0;
        const percentageUnsold = stage.numUnits ? (totalUnsold / stage.numUnits) : 0;

        return {
            ...stage,
            percentageSold,
            percentageUnsold,
            totalUnits: getZeroAsNull(stage.numUnits),
            totalSoldUnits: getZeroAsNull(stage.numberSold),
            precentageSold: percentageSold,
            totalUnsoldUnits: getZeroAsNull(totalUnsold),
            precentageUnsold: percentageUnsold,

            totalAveragePrice: getZeroAsNull(stage.totalStatisticsValues?.avaragePrice),
            totalPricePerM2: getZeroAsNull(stage.totalStatisticsValues?.avaragePricePerSqm),
            totalAverageSqm: getZeroAsNull(stage.totalStatisticsValues?.avarageSqm),
            totalPrice: getZeroAsNull(stage.totalStatisticsValues?.totalPrice),

            totalSoldAveragePrice: getZeroAsNull(stage.totalStatisticsSoldValues?.avaragePrice),
            totalSoldPricePerM2: getZeroAsNull(stage.totalStatisticsSoldValues?.avaragePricePerSqm),
            totalSoldAverageSqm: getZeroAsNull(stage.totalStatisticsSoldValues?.avarageSqm),
            totalSoldPrice: getZeroAsNull(stage.totalStatisticsSoldValues?.totalPrice),

            totalUnsoldAveragePrice: getZeroAsNull(stage.totalStatisticsUnsoldValues?.avaragePrice),
            totalUnsoldPricePerM2: getZeroAsNull(stage.totalStatisticsUnsoldValues?.avaragePricePerSqm),
            totalUnsoldAverageSqm: getZeroAsNull(stage.totalStatisticsUnsoldValues?.avarageSqm),
            totalUnsoldPrice: getZeroAsNull(stage.totalStatisticsUnsoldValues?.totalPrice),
        } as IStageTotals;
    });
}

export function buildUnitsData(projectData: INewDwellingProjectData, projectTotals: IProjectTotals): INewDwellingProspectUnits {
    const model = projectData?.projectInfo?.stageEstateTypesModel;
    return {
        units: [],
        totalPrice: projectTotals.totalPrice,
        totalPricePerSqm: projectTotals.totalPricePerM2,
        totalSqm: projectTotals.totalAverageSqm,
        maxFloorSpace: null,
        maxNumberOfRooms: null,
        maxSalePrice: null,
        minFloorSpace: null,
        minNumberOfRooms: null,
        minSalePrice: null,
        totalStatisticsValues: model?.totalStatisticsValues,
        totalStatisticsSoldValues: model?.totalStatisticsSoldValues,
        totalStatisticsUnsoldValues: model?.totalStatisticsUnsoldValues,
    };
}
